import React, { useMemo, useState } from "react";

function CarFeatureList({ features = [] }) {
  const [showModal, setShowModal] = useState(false);
  const previewCount = 8;

  const normalized = useMemo(
    () => (Array.isArray(features) ? features : []).map((f) => String(f).trim()).filter(Boolean),
    [features]
  );
  const previewFeatures = normalized.slice(0, previewCount);
  const hasMore = normalized.length > previewCount;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <h3 className="text-base font-semibold text-slate-900">Features</h3>
        <span className="text-xs text-slate-500">{normalized.length} listed</span>
      </div>

      <ul className="flex flex-wrap gap-2">
        {previewFeatures.map((f, i) => (
          <li
            key={`${f}-${i}`}
            className="list-none rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm text-slate-700"
          >
            {f}
          </li>
        ))}
        {hasMore && (
          <li className="list-none">
            <button
              onClick={() => setShowModal(true)}
              className="rounded-full border border-blue-200 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100"
            >
              View all
            </button>
          </li>
        )}
      </ul>

      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) setShowModal(false);
          }}
        >
          <div className="w-full max-w-2xl max-h-[90vh] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
              <h3 className="text-base font-semibold text-slate-900">All features</h3>
              <button
                onClick={() => setShowModal(false)}
                className="rounded-full p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-700"
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            <div className="max-h-[calc(90vh-56px)] overflow-y-auto px-4 py-4">
              <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                {normalized.map((f, i) => (
                  <li key={`${f}-${i}`} className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CarFeatureList;
